import { jsx as i, jsxs as h, Fragment as G } from "react/jsx-runtime";
import { forwardRef as J, useState as I, createRef as K, useRef as Q, useCallback as E, useEffect as D, useImperativeHandle as U, createElement as W } from "react";
import { createPortal as Z } from "react-dom";
import { createRoot as X } from "react-dom/client";
import e from "./styles.module.less.js";
import { LoadingSpinner as w } from "./loading-spinner/index.js";
import { useDisableScroll as Y } from "../../../utils/use-disable-scroll.js";
const F = J(
  ({
    children: f,
    defaultOpen: L = !1,
    onClose: o,
    onOpen: n,
    className: C = "",
    logo: a = !0,
    titleIcon: g,
    title: v,
    description: $,
    primaryButton: c,
    secondaryPrimaryButton: t,
    secondaryButton: r,
    secondarySection: d,
    footerText: s,
    hideCloseButton: T = !1,
    useAuthStyle: M = !1,
    fullscreen: _ = !1,
    isSimple: j = !1,
    blockScroll: R = !1,
    classNames: l,
    closeIcon: x
  }, S) => {
    const [m, H] = I(L), [b, k] = I(!1), V = K(), u = Q(null);
    Y({ isDisabled: m });
    const q = E(() => {
      u.current && (clearTimeout(u.current), u.current = null), k(!1), H(!0), n == null || n();
    }, [n]), p = E(() => {
      b || (k(!0), u.current = setTimeout(() => {
        H(!1), k(!1), o == null || o();
      }, 200));
    }, [b, o]);
    D(() => () => {
      u.current && clearTimeout(u.current);
    }, []), D(() => {
      R && (m ? document.body.style.overflow = "hidden" : m === !1 && (document.body.style.overflow = "auto"));
    }, [m, R]);
    const z = E(() => {
      r == null || r.onClick(), p();
    }, [r, p]);
    return U(S, () => ({
      openModal: q,
      closeModal: p
    })), m ? j ? Z(
      /* @__PURE__ */ i(
        "div",
        {
          className: `${e.modal} ${C}  ${(l == null ? void 0 : l.container) ?? ""} ${b ? e.closing : ""} ${_ ? e.fullscreen : ""}`,
          children: /* @__PURE__ */ h(
            "div",
            {
              className: `${e.modalSimpleContent} ${(l == null ? void 0 : l.content) ?? ""}`,
              children: [
                !T && /* @__PURE__ */ i("div", { className: e.close, onClick: p, children: x ?? /* @__PURE__ */ i(
                  "svg",
                  {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ i(
                      "path",
                      {
                        d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z",
                        fill: "#B0B7BD"
                      }
                    )
                  }
                ) }),
                f
              ]
            }
          )
        }
      ),
      document.body
    ) : Z(
      /* @__PURE__ */ i(
        "div",
        {
          className: `${e.modal} ${C ?? ""} ${(l == null ? void 0 : l.container) ?? ""} ${b ? e.closing : ""} ${_ ? e.fullscreen : ""}`,
          children: /* @__PURE__ */ h(
            "div",
            {
              ref: V,
              className: `${e.modalContent} ${(l == null ? void 0 : l.content) ?? ""} ${b ? e.closing : ""} ${M ? e.authStyle : ""} ${_ ? e.fullscreen : ""}`,
              children: [
                !T && /* @__PURE__ */ i(
                  "div",
                  {
                    className: `${e.close} ${(l == null ? void 0 : l.closeButton) ?? ""}`,
                    onClick: p,
                    children: x ?? /* @__PURE__ */ i(
                      "svg",
                      {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "#B0B7BD",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /* @__PURE__ */ i("path", { d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z" })
                      }
                    )
                  }
                ),
                a && /* @__PURE__ */ i("div", { className: `${e.logo} ${(l == null ? void 0 : l.logo) ?? ""}`, children: /* @__PURE__ */ h(
                  "svg",
                  {
                    width: "48",
                    height: "48",
                    viewBox: "0 0 48 48",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                      /* @__PURE__ */ h("g", { clipPath: "url(#clip0_6687_23096)", children: [
                        /* @__PURE__ */ i(
                          "path",
                          {
                            d: "M24 48C37.2548 48 48 37.2548 48 24H36C36 30.6274 30.6274 36 24 36C17.3726 36 12 30.6274 12 24C12 17.3726 17.3726 12 24 12V0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
                            fill: "#0E5FE3"
                          }
                        ),
                        /* @__PURE__ */ i(
                          "path",
                          {
                            d: "M40 16C44.4183 16 48 12.4183 48 7.99999C48 3.58173 44.4183 0 40 0C35.5817 0 32 3.58173 32 7.99999C32 12.4183 35.5817 16 40 16Z",
                            fill: "#0E5FE3"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_6687_23096", children: /* @__PURE__ */ i("rect", { width: "48", height: "48", fill: "white" }) }) })
                    ]
                  }
                ) }),
                v && /* @__PURE__ */ h("div", { className: e.titleContainer, children: [
                  g && /* @__PURE__ */ i("div", { className: e.titleIcon, children: g }),
                  /* @__PURE__ */ i(
                    "h2",
                    {
                      className: `${e.title} ${M ? e.authStyle : ""}`,
                      dangerouslySetInnerHTML: { __html: v }
                    }
                  )
                ] }),
                $ && /* @__PURE__ */ i(
                  "div",
                  {
                    className: `${e.description} ${(l == null ? void 0 : l.description) ?? ""} ${M ? e.authStyle : ""}`,
                    dangerouslySetInnerHTML: { __html: $ }
                  }
                ),
                f && /* @__PURE__ */ i("div", { className: e.content, children: /* @__PURE__ */ i("div", { className: e.childrenContainer, children: f }) }),
                (c || t || r) && /* @__PURE__ */ h("div", { className: e.buttonContainer, children: [
                  c && /* @__PURE__ */ i(
                    "button",
                    {
                      className: e.primaryButton,
                      onClick: c.onClick,
                      disabled: c.pending || c.disabled,
                      children: c.pending ? /* @__PURE__ */ i(w, {}) : c.label
                    }
                  ),
                  t && /* @__PURE__ */ i(
                    "button",
                    {
                      className: e.primaryButton,
                      onClick: t.onClick,
                      disabled: t.pending || t.disabled,
                      children: t.pending ? /* @__PURE__ */ i(w, {}) : t.label
                    }
                  ),
                  r && /* @__PURE__ */ i(
                    "button",
                    {
                      className: e.secondaryButton,
                      onClick: z,
                      disabled: r.pending || r.disabled,
                      children: r.pending ? /* @__PURE__ */ i(w, {}) : r.label
                    }
                  )
                ] }),
                d && /* @__PURE__ */ h(G, { children: [
                  /* @__PURE__ */ i("div", { className: e.separator }),
                  /* @__PURE__ */ h("div", { className: e.secondarySectionContainer, children: [
                    (d.title || d.description) && /* @__PURE__ */ h("div", { className: e.secondarySectionTextContainer, children: [
                      d.title && /* @__PURE__ */ i("div", { className: e.secondarySectionTitle, children: d.title }),
                      d.description && /* @__PURE__ */ i(
                        "div",
                        {
                          className: e.secondarySectionDescription,
                          dangerouslySetInnerHTML: { __html: d.description }
                        }
                      )
                    ] }),
                    d.button && /* @__PURE__ */ i(
                      "button",
                      {
                        className: e.primaryButton,
                        onClick: d.button.onClick,
                        disabled: d.button.pending || d.button.disabled,
                        children: d.button.pending ? /* @__PURE__ */ i(w, {}) : d.button.label
                      }
                    )
                  ] })
                ] }),
                typeof s == "string" ? /* @__PURE__ */ i(
                  "div",
                  {
                    className: e.footer,
                    dangerouslySetInnerHTML: { __html: s }
                  }
                ) : s
              ]
            }
          )
        }
      ),
      document.body
    ) : null;
  }
);
F.displayName = "Modal";
const ie = (f, L = !1) => {
  const o = document.createElement("div");
  document.body.appendChild(o);
  const n = { current: null };
  let C = !1;
  const a = X(o), g = () => {
    C && n.current ? n.current.openModal() : setTimeout(() => g(), 0);
  }, v = () => {
    C && n.current && n.current.closeModal();
  }, $ = () => {
    if (n.current)
      n.current.closeModal(), setTimeout(() => {
        try {
          a.unmount(), document.body.contains(o) && document.body.removeChild(o);
        } catch (t) {
          console.error("Error destroying modal:", t);
        }
      }, 300);
    else
      try {
        a.unmount(), document.body.contains(o) && document.body.removeChild(o);
      } catch (t) {
        console.error("Error destroying modal:", t);
      }
  }, c = W(F, {
    ...f,
    ref: (t) => {
      t && (n.current = t, C = !0, L && n.current.openModal());
    },
    // Ensure we properly handle the onClose event
    onClose: () => {
      f.onClose && f.onClose();
    }
  });
  return a.render(c), {
    open: g,
    close: v,
    destroy: $
  };
};
export {
  F as Modal,
  ie as createModal
};
